import { render, staticRenderFns } from "./t.vue?vue&type=template&id=71fda1fc&scoped=true"
import script from "./t.vue?vue&type=script&lang=js"
export * from "./t.vue?vue&type=script&lang=js"
import style0 from "./t.vue?vue&type=style&index=0&id=71fda1fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fda1fc",
  null
  
)

export default component.exports